<mat-form-field class="full-width ts-selector" [class.ts-selector--error]="!!error" floatLabel="never">
  <span *ngIf="!value" class="hint">{{ hint }}</span>

  <mat-select
    [attr.aria-label]="ariaLabel"
    tsMatSelectInfiniteScroll
    panelClass="algorithm-selector-panel"
    (lastItemReached)="lastItemReached.emit()"
    [value]="value"
    [compareWith]="checkIfItemIsSelected"
    (selectionChange)="onSelectionChange($event.value)"
    data-cy="algorithm-selector"
  >
    <mat-select-trigger *ngIf="value">
      <span class="algorithm-row algorithm-row--trigger">
        <span class="name">{{ value.name }}</span>
        <span class="version">{{ value.version }}</span>
        <span class="trigger-end">
          <span *ngIf="value.deprecated" class="deprecated">
            {{ 'table.algorithms.columns.deprecated' | translate | uppercase }}
          </span>
          <span *ngIf="!value.deprecated && value.regulated" class="regulated">
            {{ 'table.algorithms.columns.regulated' | translate | uppercase }}
          </span>
          <button
            type="button"
            class="clear-btn"
            [attr.aria-label]="'pipeline_step_editor.algorithm_selector.clear' | translate"
            (click)="clearSelection($event)"
            data-cy="algorithm-selector-clear"
          >
            <i class="ri-close-line" aria-hidden="true"></i>
          </button>
        </span>
      </span>
    </mat-select-trigger>

    <div class="sticky-search">
      <ts-search-bar class="search-bar" [searchValue]="searchTerm" (searchChanged)="searchTermChanged.emit($event)"></ts-search-bar>
    </div>

    <div *ngIf="error" class="error-message" role="alert">
      <i class="ri-error-warning-line" aria-hidden="true"></i>
      <span>{{ error | translate }}</span>
    </div>

    <mat-option
      *ngFor="let item of allOptions; trackBy: trackById"
      [value]="item"
      [matTooltip]="item.description || ''"
      [matTooltipShowDelay]="tooltipShowDelay"
      [matTooltipDisabled]="!item.description"
    >
      <span class="algorithm-row">
        <span class="name">{{ item.name }}</span>
        <span class="version">{{ item.version }}</span>
        <span *ngIf="item.deprecated" class="deprecated">
          {{ 'table.algorithms.columns.deprecated' | translate | uppercase }}
        </span>
        <span *ngIf="!item.deprecated && item.regulated" class="regulated">
          {{ 'table.algorithms.columns.regulated' | translate | uppercase }}
        </span>
      </span>
    </mat-option>

    <!-- Hidden placeholder so the panel opens while loading or empty -->
    <mat-option *ngIf="!loaded || allOptions.length === 0" disabled style="display: none"></mat-option>

    <div *ngIf="!loaded" class="spinner-container">
      <mat-spinner diameter="24"></mat-spinner>
    </div>

    <div *ngIf="loaded && allOptions.length === 0" class="no-items">
      {{ noItemsMessage }}
    </div>
  </mat-select>
</mat-form-field>
